import { CLASS_NAME } from 'constants/class-names'
import { EventType } from 'constants/enums'
import { ComponentBase } from 'utils/abstract-classes/component-base'

export class FocusInViewComponent extends ComponentBase {
    private readonly focusAbleElementsSelector =
        'a, button, input, select, textarea, details, iframe, audio, video, [tabindex="0"]'
    // eslint-disable-next-line  no-magic-numbers
    private readonly gutter = 16

    public constructor(private element: HTMLElement) {
        super()

        const focusArray = this.focusAbleElementsSelector.split(', ')
        if (focusArray.includes(element.nodeName.toLowerCase())) {
            element.addEventListener(EventType.FOCUS, () => {
                this.scrollFocusInView()
            })
        } else {
            const focusAble = this.getElements(
                this.focusAbleElementsSelector,
                element
            )

            focusAble.forEach((focus) => {
                focus.addEventListener(EventType.FOCUS, () => {
                    this.scrollFocusInView()
                })
            })
        }
    }

    private get headerOffsets(): HTMLElement[] {
        return this.getElements(`.${CLASS_NAME.header.offset}`)
    }

    public get totalHeaderOffset(): number {
        if (!this.headerOffsets.length) {
            return this.gutter
        }
        let totalOffset = this.gutter
        this.headerOffsets.forEach((element) => {
            totalOffset += element.offsetHeight
        })
        return totalOffset
    }

    /**
     * scrollTabInView
     */
    public scrollFocusInView(): void {
        const headerOffset = this.totalHeaderOffset
        const scrollTop = this.element.offsetTop - headerOffset
        window.scroll({
            top: scrollTop,
            behavior: 'smooth'
        })
    }
}
